(exports.GAME_ID = "6257cd676db41c00165032cf"),
(exports.FORM_ID = "6257cd796db41c00165032d2"),
(exports.STATUS_FORM_ID = "604098955f01640015a8f8f1"),
(exports.SERVER_URL = "https://api-gabarit.promo.dev"),
(exports.BD_NAME = "jeu-dev");